import api from 'Application/api/api';

const getMyTeamActiveProjectById = (signal, id) =>
	api.get(`/projects/my-team-active-project-by-id/${id}`, {
		signal,
	});

export default getMyTeamActiveProjectById;
